<template>
  <section class="team-section" id="team">
    <div class="team-container">
      <div class="section-header">
        <h2 class="section-title">团队与保障</h2>
        <div class="title-underline"></div>
      </div>

      <div class="team-intro">
        围绕数控机床的维修、保养、检测、搬迁与改造，我们采用“专业分工 + 现场协同 + 过程记录”的服务方式，
        让每一次处理都有依据、可复盘、可持续优化。
      </div>

      <div class="team-grid">
        <div class="team-card" v-for="(c, idx) in cards" :key="idx">
          <div class="card-icon">{{ c.icon }}</div>
          <div class="card-title">{{ c.title }}</div>
          <div class="card-desc">{{ c.desc }}</div>
          <ul class="card-list" v-if="c.points && c.points.length">
            <li v-for="(p, pIdx) in c.points" :key="pIdx">{{ p }}</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TeamSection',
  data() {
    return {
      cards: [
        {
          icon: '技',
          title: '多专业技术覆盖',
          desc: '面向机械、电气、液压/润滑、数控系统等方向协同处理，针对精度与稳定性问题提供组合式方案。',
          points: ['故障诊断与复现', '关键部位拆装与调试', '精度恢复与验证'],
        },
        {
          icon: '快',
          title: '高效响应机制',
          desc: '针对紧急停机、产线节拍等场景，优先响应、快速定位、分级处理，减少等待与试错。',
          points: ['应急响应', '现场处置', '复机验证'],
        },
        {
          icon: '档',
          title: '档案与数据管理',
          desc: '在年度保障与深度保养服务中建立与维护设备档案，沉淀关键参数、备份数据与历史记录。',
          points: ['数据备份', '故障记录', '维保计划与复盘'],
        },
        {
          icon: '质',
          title: '交付可验证',
          desc: '通过检测记录、测试结果与过程工单，让交付结果可追溯；需要时提供精度恢复与风险建议。',
          points: ['检测记录', '调试结果', '交付建议'],
        },
      ],
    };
  },
};
</script>

<style scoped>
.team-section {
  background: #ffffff;
  padding: 80px 0;
}

.team-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.section-header {
  margin-bottom: 26px;
}

.section-title {
  font-size: 2rem;
  font-weight: 800;
  color: #1a1a2e;
  margin-bottom: 12px;
  letter-spacing: 1px;
}

.title-underline {
  width: 60px;
  height: 3px;
  background: #1976d2;
  border-radius: 2px;
}

.team-intro {
  color: #4b5563;
  line-height: 1.9;
  font-size: 1rem;
  max-width: 960px;
}

.team-grid {
  margin-top: 22px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px;
}

.team-card {
  background: #ffffff;
  border: 1px solid #eef2f7;
  border-radius: 18px;
  padding: 18px 18px 16px 18px;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.04);
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.team-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 16px 38px rgba(25, 118, 210, 0.10);
  border-color: #dbeafe;
}

.card-icon {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: rgba(25, 118, 210, 0.12);
  color: #1976d2;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  letter-spacing: 2px;
  margin-bottom: 12px;
}

.card-title {
  font-size: 1.05rem;
  font-weight: 900;
  color: #1a1a2e;
  margin-bottom: 10px;
}

.card-desc {
  color: #4b5563;
  line-height: 1.8;
  font-size: 0.95rem;
  margin-bottom: 10px;
}

.card-list {
  margin: 0;
  padding-left: 18px;
  color: #4b5563;
  line-height: 1.75;
  font-size: 0.92rem;
}

@media (max-width: 1024px) {
  .team-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .team-section {
    padding: 56px 0;
  }
  .team-grid {
    grid-template-columns: 1fr;
  }
}
</style>
